import React, { useEffect } from 'react';
import MdaeNumericBox from "../numeric-box";
import "./index.scss";
import { useDispatch, useSelector } from 'react-redux';
import { actions as asyncActions } from "async-ops";
import dxDataGrid from 'devextreme/ui/data_grid';

export interface IDataGridRecordsFilterProps {
    fetchOptions: {
        reducerName: string;
        fetchActionType: string;
        valueActionType: string;
        data?: any;
    };
    rangeNumber: number;
    prefixText: string;
    suffixText: string;
    infoText: string;
    titleText: string;
    id: string;
    isFetchedByGrid?: boolean;
    gridId?: string;
}


const DataGridRecordsFilter: React.FC<IDataGridRecordsFilterProps> = (props) => {
    const dispatch = useDispatch();
    const headerRangeFilterCount = useSelector((state: any) => state[props.fetchOptions.reducerName].headerRangeFilterCount);
    const fetchData = () => {
      if (props.isFetchedByGrid) {
        const dataGrid = dxDataGrid.getInstance(
          document.getElementById(props.gridId)
        ) as dxDataGrid;
        dataGrid.getDataSource().reload();
      } else {
        let fetchDataGrid = {};
        if (props.fetchOptions.data)
          fetchDataGrid = asyncActions.asyncOperationStart(
            props.fetchOptions.fetchActionType,
            { headerRangeFilterCount, ...props.fetchOptions.data }
          );
        else
          fetchDataGrid = asyncActions.asyncOperationStart(
            props.fetchOptions.fetchActionType,
            headerRangeFilterCount
          );
        dispatch(fetchDataGrid);
      }
    };
    useEffect(() => {
        if(!props.isFetchedByGrid)
            fetchData();
        
        dispatch({
          type: props.fetchOptions.valueActionType,
          data:{
            headerRangeFilterCount: props.rangeNumber
          }
        })
    }, []);
    return (
        <div className="data-grid-records-filter">
            <div >{props.prefixText}</div>
            <MdaeNumericBox
                id={props.id}
                className="middle-input"
                defaultValue={props.rangeNumber}
                mdaeDataUpdaterConfig={[
                    {
                        actionType: props.fetchOptions.valueActionType,
                        reducerName: props.fetchOptions.reducerName,
                        widgetOptionBindings: {
                            value: 'headerRangeFilterCount'
                        }
                    }
                ]}
                min={1}
                max={9999}
                format='######'
                width={80} />
            <div className="suffix-text">{props.suffixText}</div>
            <span className="info-icon" title={props.infoText}><i className="img-circle fa fa-info-circle audit-info-circle"></i></span>
            <span className="refresh-data-grid-button" title={props.titleText} onClick={fetchData}>
                <i className="dx-icon-pulldown teal-color"></i>
            </span>
        </div>

    );
}

export default DataGridRecordsFilter;